import { render, staticRenderFns } from "./floating-menu.vue?vue&type=template&id=4b1f447a&scoped=true"
import script from "./floating-menu.vue?vue&type=script&lang=js"
export * from "./floating-menu.vue?vue&type=script&lang=js"
import style0 from "./floating-menu.vue?vue&type=style&index=0&id=4b1f447a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f447a",
  null
  
)

export default component.exports